module.exports = __webpack_public_path__ + "img/becoming.454d6406.jpg";